<template>
  <!-- 已服务客户 -->
  <div class="ab-customer-list">
    <ab-block title="已服务客户" subTitle="10w+客户的信任与选择">
      <div class="logo-list warp">
        <ab-customers></ab-customers>
        <!-- <dl class="clearfix">
          <dd>
            <div class="">
              <a href="#" target="_blank"
                ><img src="~@/assets/home/pic_7.jpg" alt=""
              /></a>
            </div>
          </dd>
          <dd>
            <div class="">
              <a href="#" target="_blank"
                ><img src="~@/assets/home/pic_7.jpg" alt=""
              /></a>
            </div>
          </dd>
          <dd>
            <div class="">
              <a href="#" target="_blank"
                ><img src="~@/assets/home/pic_7.jpg" alt=""
              /></a>
            </div>
          </dd>
          <dd>
            <div class="">
              <a href="#" target="_blank"
                ><img src="~@/assets/home/pic_7.jpg" alt=""
              /></a>
            </div>
          </dd>
          <dd>
            <div class="">
              <a href="#" target="_blank"
                ><img src="~@/assets/home/pic_7.jpg" alt=""
              /></a>
            </div>
          </dd>
          <dd>
            <div class="">
              <a href="#" target="_blank"
                ><img src="~@/assets/home/pic_7.jpg" alt=""
              /></a>
            </div>
          </dd>
          <dd>
            <div class="">
              <a href="#" target="_blank"
                ><img src="~@/assets/home/pic_7.jpg" alt=""
              /></a>
            </div>
          </dd>
          <dd>
            <div class="">
              <a href="#" target="_blank"
                ><img src="~@/assets/home/pic_7.jpg" alt=""
              /></a>
            </div>
          </dd>
          <dd>
            <div class="">
              <a href="#" target="_blank"
                ><img src="~@/assets/home/pic_7.jpg" alt=""
              /></a>
            </div>
          </dd>
          <dd>
            <div class="">
              <a href="#" target="_blank"
                ><img src="~@/assets/home/pic_7.jpg" alt=""
              /></a>
            </div>
          </dd>
          <dd>
            <div class="">
              <a href="#" target="_blank"
                ><img src="~@/assets/home/pic_7.jpg" alt=""
              /></a>
            </div>
          </dd>
          <dd>
            <div class="">
              <a href="#" target="_blank"
                ><img src="~@/assets/home/pic_7.jpg" alt=""
              /></a>
            </div>
          </dd>
          <dd>
            <div class="">
              <a href="#" target="_blank"
                ><img src="~@/assets/home/pic_7.jpg" alt=""
              /></a>
            </div>
          </dd>
          <dd>
            <div class="">
              <a href="#" target="_blank"
                ><img src="~@/assets/home/pic_7.jpg" alt=""
              /></a>
            </div>
          </dd>
          <dd>
            <div class="">
              <a href="#" target="_blank"
                ><img src="~@/assets/home/pic_7.jpg" alt=""
              /></a>
            </div>
          </dd>
          <dd>
            <div class="">
              <a href="#" target="_blank"
                ><img src="~@/assets/home/pic_7.jpg" alt=""
              /></a>
            </div>
          </dd>
          <dd>
            <div class="">
              <a href="#" target="_blank"
                ><img src="~@/assets/home/pic_7.jpg" alt=""
              /></a>
            </div>
          </dd>
          <dd>
            <div class="">
              <a href="#" target="_blank"
                ><img src="~@/assets/home/pic_7.jpg" alt=""
              /></a>
            </div>
          </dd>
        </dl> -->
      </div>
    </ab-block>
  </div>
</template>

<script>
import AbBlock from '@/components/AbBlock.vue';
import AbCustomers from '@/components/AbCustomers.vue';
export default {
  components: {
    AbBlock,
    AbCustomers,
  },
  props: {
    columnVal: {
      type: String,
      default: '6',
    },
    gutterVal: {
      type: String,
      default: '0',
    },
  },
  data() {
    return {
      column: this.columnVal,
      gutter: this.gutterVal,
      list: [],
    };
  },
};
</script>

<style lang="sass" scoped>
.ab-customer-list{
  height: 730px;
  background: url(~@/assets/product/背景_已服务客户.jpg) -1px -1px no-repeat;
  background-size: cover;
  // width: 1500px;
  // margin: 20px 0 0 20px;
  padding-top: 60px;
  padding-bottom: 81px;
  .logo-list{
    margin-top: 35px;
    background: #fff;
    border-radius: 8px;
    opacity: 0.95;

    // dd div img{
    //   max-width: 100%
    // }

    // dl{
    //   padding: 20px 50px;
    // }
    // dd{
    //     float: left;
    //     width: 16.666666%;

    // }
    // dd div{
    //   text-align: center;
    //   height: 140px;
    //   line-height: 140px;
    //   border: 1px solid #eee;

    // }

    // dd:hover div{
    //   box-shadow: 8px 8px 20px 0 rgb(55 99 170 / 10%), -8px -8px 20px 0 #fff, inset 0 4px 20px 0 hsl(0deg 0% 100% / 50%);
    // }
  }
}
</style>
